import { render, staticRenderFns } from "./HyroxAdmin.vue?vue&type=template&id=8c1f1746"
import script from "./HyroxAdmin.vue?vue&type=script&lang=js"
export * from "./HyroxAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports